module.exports = __webpack_public_path__ + "img/tws7.ec3a1c82.png";